import { useEffect } from "react";
import { UseQueryResult, useQueryClient } from "react-query";

const EMPTY_KEY_SUFFIX: never[] = [];

// Seeds a per-patient query cache from a list-batch response so that opening qcard
// from the patient list hits cache instead of network. Iterates over patientIDs (not
// the response keys) so patients with no data still get a defaultValue seeded —
// otherwise qcard would fetch on open for those patients.
// keySuffix is appended after the patient ID for queries whose key includes extra
// dimensions (e.g. ["patientdispositions", patientID, includeHistory]).
export const usePatientListCache = <T>(
  query: UseQueryResult<Record<number, T>>,
  keyPrefix: string,
  patientIDs: number[],
  defaultValue: T | null,
  keySuffix: readonly unknown[] = EMPTY_KEY_SUFFIX
): void => {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!query.data) return;
    for (const pid of patientIDs) {
      queryClient.setQueryData(
        [keyPrefix, pid, ...keySuffix],
        query.data[pid] ?? defaultValue
      );
    }
  }, [query.data, queryClient, keyPrefix, patientIDs, defaultValue, keySuffix]);
};
